import * as React from 'react'
import Button from '@mui/material/Button'
import CssBaseline from '@mui/material/CssBaseline'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import UserLayout from '../layouts/UserLayout'
import { FormControl, Typography } from '@mui/material'
import axios from 'axios'
import { handleError } from '../utils/error'
import { api } from '../utils/api'
import { useNavigate } from 'react-router-dom'
import { currentUserActions } from '../redux/store'
import { useDispatch } from 'react-redux'
import { borderFormat, mainGreen } from '../utils/color'

export default function ForgotPassword() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const emailRef = React.useRef()

	const forgotPassword = async function (email) {
		try {
			const response = await axios({
				url: api.FORGOT_PASSWORD,
				method: 'POST',
				data: { email },
			})
			if (response.status === 200) {
				alert(response.data.message)
			}
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	const handleSubmit = (event) => {
		event.preventDefault()
		forgotPassword(emailRef.current.value)
	}

	return (
		<UserLayout>
			<Container sx={{ padding: '20px', mt: '5%' }} maxWidth='sm'>
				<CssBaseline />
				<div style={{ textAlign: 'center', marginBottom: '1rem' }}>
					<img
						src='/img/logo.jpg'
						alt='logo'
						width='150px'
						style={{
							borderRadius: '1rem',
							border: borderFormat,
						}}
					/>
				</div>
				<Box component='form' onSubmit={handleSubmit} noValidate sx={{ m: 0 }}>
					<FormControl fullWidth>
						<Typography>Điền email đăng ký để lấy lại mật khẩu</Typography>
						<TextField inputRef={emailRef} margin='normal' fullWidth label='Email' autoComplete='email' autoFocus />
					</FormControl>
					<Button
						type='submit'
						fullWidth
						variant='contained'
						sx={{
							mt: 2,
							mb: 2,
							background: mainGreen,
							'&:hover': { background: mainGreen },
						}}>
						Gửi
					</Button>
				</Box>
				<Box sx={{ textAlign: 'center' }}>
					<Button
						variant='text'
						size='small'
						sx={{
							color: mainGreen,
							'&:hover': { color: mainGreen },
						}}
						onClick={() => {
							navigate('/login')
						}}>
						Đăng nhập
					</Button>
				</Box>
			</Container>
		</UserLayout>
	)
}
